"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alert = alert;
exports.default = void 0;
exports.error = error;
exports.success = success;
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/web.timers.js");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _ConfigProvider = _interopRequireDefault(require("../ConfigProvider"));
var _noop = require("../_utils/noop");
var _index = require("../Transition/index");
var _useMsgRoot = require("../_utils/hooks/useMsgRoot");
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _callBoth = require("../_utils/callBoth");
var _useVisibleTransition2 = require("../_utils/hooks/useVisibleTransition");
var _useOutsideClick2 = require("../_utils/hooks/useOutsideClick");
var _excluded = ["onClose"],
  _excluded2 = ["type", "className", "style", "message", "description", "closeButton", "duration", "onClose", "disableOutsideClick"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * API 的方式唤起一个告警对话框
 * @param options
 */
function alert(_ref) {
  var _ref$onClose = _ref.onClose,
    _onClose = _ref$onClose === void 0 ? _noop.noop : _ref$onClose,
    options = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  // return new Promise<void>(resolve => {
  var el = document.createElement('div');
  var instanceRef = /*#__PURE__*/_react.default.createRef();
  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_ConfigProvider.default, {
    classPrefix: options.prefix
  }, /*#__PURE__*/_react.default.createElement(MsgAlert, (0, _extends2.default)({}, options, {
    ref: instanceRef,
    onClose: function onClose() {
      _onClose();
      _reactDom.default.unmountComponentAtNode(el);
    }
  }))), el);
  var hide = function hide() {
    if (instanceRef.current) {
      instanceRef.current.setVisible(false);
    }
  };
  var handle = {
    hide: hide,
    destroy: hide
  };
  var maxCountLimit = 1;
  var listKey = "unv-msg-list-identification\"";
  if ((typeof window === "undefined" ? "undefined" : (0, _typeof2.default)(window)) === 'object') {
    if (!window[listKey]) {
      window[listKey] = [];
    }
    if (window[listKey].length >= maxCountLimit) {
      try {
        window[listKey][0].hide();
        window[listKey].shift();
      } catch (_) {
        // hide failed
      }
    }
    window[listKey].push(handle);
  }
  // });
}

/**
 * API 的方式唤起一个对话框显示成功信息
 */
function success(options) {
  return alert(_objectSpread({
    type: 'success'
  }, options));
}

/**
 * API 的方式唤起一个对话框显示失败信息
 */
function error(options) {
  return alert(_objectSpread({
    type: 'error'
  }, options));
}
var MsgAlert = /*#__PURE__*/(0, _react.forwardRef)(function MsgShow(_ref2, ref) {
  var _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? 'success' : _ref2$type,
    className = _ref2.className,
    style = _ref2.style,
    message = _ref2.message,
    description = _ref2.description,
    _ref2$closeButton = _ref2.closeButton,
    closeButton = _ref2$closeButton === void 0 ? false : _ref2$closeButton,
    _ref2$duration = _ref2.duration,
    duration = _ref2$duration === void 0 ? 3000 : _ref2$duration,
    _ref2$onClose = _ref2.onClose,
    onClose = _ref2$onClose === void 0 ? _noop.noop : _ref2$onClose,
    disableOutsideClick = _ref2.disableOutsideClick,
    rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  var comCls = (0, _usePrefixCls.usePrefixCls)('msg');
  var classes = (0, _classnames3.default)(comCls, className, "".concat(comCls, "--fixed"), (0, _defineProperty2.default)({}, "".concat(comCls, "--").concat(type), !!type), (0, _defineProperty2.default)({}, "".concat(comCls, "--closable"), !!closeButton));
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      setVisible: setVisible
    };
  });
  var timerRef = (0, _react.useRef)(null);
  var msgRoot = (0, _useMsgRoot.useMsgRoot)();
  var msgRef = (0, _react.useRef)(null);
  var _useOutsideClick = (0, _useOutsideClick2.useOutsideClick)(msgRef, true, {
      isCapture: true
    }),
    listen = _useOutsideClick.listen;
  listen(function (evt) {
    if (disableOutsideClick && evt.stopImmediatePropagation) {
      evt.stopImmediatePropagation();
      evt.preventDefault();
    }
  });

  // 渲染之后，马上显示
  (0, _react.useEffect)(function () {
    setVisible(true);
    return function () {
      return clearTimeout(timerRef.current);
    };
  }, []);
  (0, _react.useLayoutEffect)(function () {
    clearTimeout(timerRef.current);
    if (visible) {
      timerRef.current = setTimeout(function () {
        return setVisible(false);
      }, duration);
    }
  }, [duration, visible]);
  var close = function close() {
    onClose();
    setVisible(false);
    clearTimeout(timerRef.current);
  };
  var _useVisibleTransition = (0, _useVisibleTransition2.useVisibleTransition)(visible),
    shouldContentEnter = _useVisibleTransition.shouldContentEnter,
    shouldContentRender = _useVisibleTransition.shouldContentRender,
    onContentExit = _useVisibleTransition.onContentExit;
  if (!shouldContentRender) {
    return null;
  }
  var messages = /*#__PURE__*/_react.default.createElement(_index.FadeTransition, {
    in: shouldContentEnter,
    onExited: (0, _callBoth.callBoth)(onClose, onContentExit)
  }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes,
    style: _objectSpread({
      zIndex: 1100
    }, style)
  }, rest, {
    ref: msgRef,
    onMouseEnter: function onMouseEnter() {
      return clearTimeout(timerRef.current);
    },
    onMouseLeave: function onMouseLeave() {
      timerRef.current = setTimeout(function () {
        return setVisible(false);
      }, duration);
    }
  }), /*#__PURE__*/_react.default.createElement("i", {
    className: "".concat(comCls, "__icon")
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(comCls, "__cont")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(comCls, "__title")
  }, message), !!description && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(comCls, "__desc")
  }, description)), !!closeButton && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(comCls, "__close"),
    onClick: close
  })));
  return /*#__PURE__*/_reactDom.default.createPortal(messages, msgRoot);
});
var _default = exports.default = MsgAlert;